import { render, staticRenderFns } from "./dettaglioProdotti.vue?vue&type=template&id=9652c59a&scoped=true"
import script from "./dettaglioProdotti.vue?vue&type=script&lang=js"
export * from "./dettaglioProdotti.vue?vue&type=script&lang=js"
import style0 from "./dettaglioProdotti.vue?vue&type=style&index=0&id=9652c59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9652c59a",
  null
  
)

export default component.exports